/**
 * @mixin
 */

export default {
    data() {
        return {
            landingPageId: null,
            codeId: null
        };
    },
    methods: {
        /**
         * @method parsePageURL
         */
        parsePageURL() {
            let landingPageId, codeId;
            if ( process.env.NODE_ENV === 'development'
                && ( window.location.host.indexOf( 'localhost' ) !== -1 ||
                    window.location.host.indexOf( '127.0.0.1' ) !== -1 ||
                    window.location.host.indexOf( '192.168.9.91' ) !== -1 )
            ) {
                //for testing purposes
                const url = new URL( location.href );
                landingPageId = url.searchParams.get( "landingPageId" );
                codeId = url.searchParams.get( "codeId" );
                // console.log("Mode 1", landingPageId, codeId);
            } else {
                //assuming the correct url structure
                const path = window.location.pathname.slice( 1 );
                const params = path.split( '/' );
                landingPageId = params[0];
                codeId = params.length > 2 ? params[2] : null;
                // console.log("Mode 2", landingPageId, codeId);
            }
            this.landingPageId = landingPageId;
            this.codeId = codeId;
            return [landingPageId, codeId];
        }
    }
};
